<template lang="pug">
  app-button(v-bind:class="center ? 'done-btn' : ''" color="#1B93AD" :disabled="disabled" :dark="dark" @click="$emit('click')" :fixed="fixed" :bottom="bottom")
    slot
</template>

<script>
import AppButton from './AppButton'

export default {
  name: 'app-button-action',
  components: {
    [AppButton.name]: AppButton
  },

  props: {
    disabled: Boolean,
    dark: {
        default:true,
        type:Boolean
    },
    fixed: Boolean,
    bottom: Boolean,
    center: Boolean
  }
}
</script>

<style scoped>
.done-btn {
  right: calc(50% - 205px);
  bottom: 25px;
}
</style>
